<!--
  文件描述：医院
  创建时间：2022/3/31 15:38
  创建人：yu
-->
<template>
  <div class="hospitalFrame">
    <div style="font-size: 4rem">象山县红十字台胞医院</div>
    <div class="textCentre">
      <div style="font-size: 9rem;margin-bottom: 14rem;">海上 120 系统</div>
      <div style="font-size: 5rem;">正在值班</div>
    </div>
    <div class="offline">
      <van-button style="font-size: 3rem;" type="warning" @click="$router.push({name: 'doctors'})">下线</van-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {clearRem, startRem} from '@/tool/rem'

export default {
  name: 'hospital',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      height: window.innerHeight
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    startRem()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  // 生命周期 - 创建之前
  beforeCreate() {
  },
  // 生命周期 - 挂载之前
  beforeMount() {
  },
  // 生命周期 - 更新之前
  beforeUpdate() {
  },
  // 生命周期 - 更新之后
  updated() {
  },
  // 生命周期 - 销毁之前
  beforeDestroy() {
  },
  // 生命周期 - 销毁完成
  destroyed() {
    clearRem()
  },
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {
  },
  // 方法集合
  methods: {}
}
</script>

<style scoped>
  .textCentre {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .offline{
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
 .hospitalFrame {
   background: rgb(65,73,88);
   height: 100vh;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   padding: 6rem;
   color: #fff;
 }
</style>
